<div>
    <div class="position-relative live-feed-container">
        <div id="chartdiv" class="live-feed-chart" style="width: 100%; min-height: 280px;"></div>
        <div *ngIf="liveFeedLoading" class="live-feed-overlay live-feed-loading">
            <span>Loading live feed…</span>
        </div>
        <div *ngIf="!liveFeedLoading && liveFeedEmpty" class="live-feed-overlay live-feed-empty">
            <p class="mb-0 text-center">No recent sales to display. The feed updates after each auction sync.</p>
        </div>
        <div class="position-absolute top-0 bottom-0 start-0" style="right: 33%; background-color: rgba(0,0,0,0.0);">
        </div>
    </div>

    <div class="mt-3">
        <pla-featured-plates [forcedRegistrations]="displayedPlates" [reversed]="true" [showIfEmpty]="false" [flex]="false"
            [showTitle]="false" [showPrice]="false" [priceFontSize]="16" [maxCount]="30" [plateClass]="'flat shaded my-2'"
            [overflow]="true" [mobileTiny]="false" [plateSize]="'ns-s'" [showIndex]="false"></pla-featured-plates>
    </div>
</div>